const toPrice = (price: string | any): string => {
	let string = price;

	if (price === null || price === undefined) {
		return '';
	}

	if (typeof price !== 'string') {
		string = price.toString();
	}

	return string.replace(/\B(?=(\d{3})+\b)/g, ',');
};

export default toPrice;
